import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/HelloWorld.vue';
import ss from '@/components/ss.vue';
import heardpc from '@/view/public/heardpc.vue';
import bottompc from '@/view/public/bottompc.vue';
import test from '@/view/public/test.vue';
import indexmain from '@/view/indexmain/indexmain.vue';
import positioning from '@/view/positioning/positioning.vue';
import exhibitioncenter from '@/view/showcenter/showcenter.vue';
import products from '@/view/products/products.vue';
import researchdesign from '@/view/researchdesign/researchdesign.vue';
import greenmanufacturing from '@/view/greenmanufacturing/greenmanufacturing.vue';
import aftersales from '@/view/aftersales/aftersales.vue';
import Instructions from '@/view/Instructions/Instructions.vue';
import Partners from '@/view/Partners/Partners.vue';
import search from '@/view/search/search.vue';
import salesnetwork from '@/view/salesnetwork/salesnetwork.vue';
import indexmainh5 from '@/view/h5/indexmianh5.vue';
import indexmainh5en from '@/view/h5/indexmianh5en.vue';
import bottomh5 from '@/view/h5/public/bottomh5.vue';
import productrange from '@/view/h5/productrange/productrange.vue';
import productrangeen from '@/view/h5/productrange/productrangeen.vue';
import bottomh5en from '@/view/h5/public/bottomh5en.vue';
import faqs from '@/view/faqs/faqs.vue';
import faqsnew from '@/view/faqs/faqsnew.vue';
import userservices from '@/view/h5/userservices/userservice.vue';
import userservicesen from '@/view/h5/userservices/userserviceen.vue';
import goshopping from '@/view/h5/goshopping/goshopping.vue';
import goshoppingen from '@/view/h5/goshopping/goshoppingen.vue';
import contactservice from '@/view/h5/contactservice/contactservice.vue';
import morecontactserver from '@/view/h5/morecontactserver/morecontactserver.vue';
import morecontactserveren from '@/view/h5/morecontactserver/morecontactserveren.vue';
import bottomcontent from '@/view/h5/public/bottomcontent.vue';
import bottomcontenten from '@/view/h5/public/bottomcontenten.vue';
import businesscooperateh5 from '@/view/h5/businesscooperateh5/businesscooperateh5.vue';
import businesscooperateh5en from '@/view/h5/businesscooperateh5/businesscooperateh5en.vue';
import salesnetworkh5 from '@/view/h5/salesnetworkh5/salesnetworkh5.vue';
import salesnetworkh5en from '@/view/h5/salesnetworkh5/salesnetworkh5en.vue';
import morequestion from '@/view/h5/morequestion/morequestion.vue';
import morequestionen from '@/view/h5/morequestion/morequestionen.vue';
Vue.use(Router);
const routes = [

    { path: '/',name:'indexmain', component: indexmain },
    { path: '/my', component: ss },
    { path: '/headpc', component: heardpc },
    { path: '/bottompc',name:'bottompc', component: bottompc },
    { path: '/test', component: test },
    { path: '/indexmain',name:'indexmain', component: indexmain },
    { path: '/positioning',name:'positioning', component: positioning },
    { path: '/exhibitioncenter',name:'exhibitioncenter', component: exhibitioncenter },
    { path: '/products/:id',name:'products', component: products },
    { path: '/researchdesign',name:'researchdesign', component: researchdesign },
    { path: '/greenmanufacturing',name:'greenmanufacturing', component: greenmanufacturing },
    { path: '/aftersales',name:'aftersales', component: aftersales },
    { path: '/Instructions',name:'Instructions', component: Instructions },
    { path: '/Partners',name:'Partners', component: Partners },
    { path: '/search',name:'search', component: search },
    { path: '/salesnetwork',name:'salesnetwork', component: salesnetwork },
    { path: '/faqs',name:'faqs', component: faqs },
    { path: '/faqsnew',name:'faqsnew', component: faqsnew },

    { path: '/indexmainh5',name:'indexmainh5', component: indexmainh5 },  
    { path: '/indexmainh5en',name:'indexmainh5en', component: indexmainh5en },  
    { path: '/bottomh5',name:'bottomh5', component: bottomh5 },  
    { path: '/productrange',name:'productrange', component: productrange },  
    { path: '/productrangeen',name:'productrangeen', component: productrangeen },  
    { path: '/bottomh5en',name:'bottomh5en', component: bottomh5en },  
    { path: '/userservices',name:'userservices', component: userservices },  
    { path: '/userservicesen',name:'userservicesen', component: userservicesen },  
    { path: '/goshopping',name:'goshopping', component: goshopping },  
    { path: '/goshoppingen',name:'goshoppingen', component: goshoppingen }, 
    { path: '/contactservice',name:'contactservice', component: contactservice },  
    { path: '/morecontactserver',name:'morecontactserver', component: morecontactserver },  
    { path: '/morecontactserveren',name:'morecontactserveren', component: morecontactserveren },  
    { path: '/bottomcontent',name:'bottomcontent', component: bottomcontent },  
    { path: '/bottomcontenten',name:'bottomcontenten', component: bottomcontenten },  
    { path: '/businesscooperateh5',name:'businesscooperateh5', component: businesscooperateh5 },  
    { path: '/businesscooperateh5en',name:'businesscooperateh5en', component: businesscooperateh5en },  
    { path: '/salesnetworkh5',name:'salesnetworkh5', component: salesnetworkh5 },  
    { path: '/salesnetworkh5en',name:'salesnetworkh5en', component: salesnetworkh5en },  
    { path: '/morequestion',name:'morequestion', component: morequestion },  
    { path: '/morequestionen',name:'morequestionen', component: morequestionen },  


  ]
  export default new Router({ 
    routes ,
         mode: 'history', 
  })